import classNames from 'classnames';
import { ReactNode } from 'react';
import Button, { ButtonProps } from '../../../components/Button';
import Typography from '../../../components/Typography';
import styles from './Page.module.scss';

export interface PageProps {
  className?: string;
  heading: string;
  description?: string | string[];
  actions?: ButtonProps<'button'>[];
  disabled?: boolean;
  children: ReactNode;
  loading?: boolean;
}

function Page({
  loading,
  className,
  heading,
  description,
  disabled,
  actions,
  children,
  ...props
}: PageProps) {
  if (loading) {
    return (
      <section {...props}>
        <Typography className={styles.loading} textType="h3" as="h1">
          Loading...
        </Typography>
      </section>
    );
  }

  return (
    <section {...props}>
      <div className={styles.header}>
        <div className={styles.heading}>
          <Typography textType="h3" as="h1">
            {heading}
          </Typography>
          <div className={styles.actions}>
            {actions?.map((action, key) => (
              <Button
                {...action}
                className={classNames(action.className, styles.action)}
                key={key}
              />
            ))}
          </div>
        </div>
        {description && (
          <Typography className={styles.description} textType="p2" as="p">
            {Array.isArray(description)
              ? description.map((line, i) => (
                  <span className={styles.line} key={i}>
                    {line}
                  </span>
                ))
              : description}
          </Typography>
        )}
      </div>
      <div className={classNames(disabled && styles.disabled, className)}>
        {children}
      </div>
    </section>
  );
}

export default Page;
